export default {
  'Choose File': 'Pilih File',
  'Please paste a URL': 'Silahkan paste URL',
  'Loading': 'Memuat',
  'Analyzing': 'Menganalisa',
  'Try a sample': 'Coba sampel',
  'Sorry, error occurs when analyzing the URL.': 'Maaf, error terjadi ketika menganalisa URL.',
}